import { Button } from '@/components/ui/button'
import { ApiError } from '@/lib/api/client'
import { m } from '@/lib/paraglide/messages'

export function EInvoiceQueryState({
    error,
    retry,
}: {
    error?: unknown
    retry: () => void
}) {
    if (!error)
        return (
            <p role="status" className="text-sm text-muted-foreground">
                {m.einvoice_query_loading()}
            </p>
        )
    return (
        <div className="space-y-2 rounded-md border p-3">
            <p role="alert" className="text-sm text-destructive">
                {error instanceof ApiError && error.message
                    ? error.message
                    : m.einvoice_query_error()}
            </p>
            <Button size="sm" variant="outline" onClick={retry}>
                {m.einvoice_viewer_retry()}
            </Button>
        </div>
    )
}
